import { render, staticRenderFns } from "./SaveOrPreviewButtons.vue?vue&type=template&id=2d45018a"
import script from "./SaveOrPreviewButtons.vue?vue&type=script&lang=ts"
export * from "./SaveOrPreviewButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports